import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { PersonEntrepreneurship } from '@interfaces';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService): GridSetup<PersonEntrepreneurship> {

	return {
		rowName: { singular: 'Entrepreneurship', plural: 'Entrepreneurships' },
		getRowKey: row => row.trimesterId + '_' + row.role + '_' + row.id,
		stateKey: 'person-explorer-entrepreneurship-grid',
		actions: getActions(dialog),
		buttons: getButtons(),
		columns: getColumns(util),
	}
}
